import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import {
  Table,
  ProgressBar,
  Company,
  CompanyStatus,
  TableParentTooltip,
  Text,
  Icon,
  DateTime,
  TableCoupon,
  WithTooltip
} from 'components/common/Elements/Elements';

import { moneyFormater, recordType } from 'utils/common';
import { useRegionalLink } from 'hooks/useRegionalLink';

import classes from './TableRow.module.scss';

const TableRow = ({ company, family, noFirst, row, mouseEnter }) => {
  const { t } = useTranslation(['activity']);
  let { url } = useRouteMatch();
  const generateRegionalPath = useRegionalLink();

  let newUrl = url.split('/');
  newUrl.pop();
  newUrl.pop();
  newUrl = newUrl.join('/');

  return (
    <Table.Row
      className={cn(classes.row, family === 'parent' && classes.row_parent)}
    >
      <Table.Cell
        className={cn(
          classes.tableCell,
          row === 'r0' && classes.hov,
          family === 'child' && classes.tableCell_child
        )}
        onMouseEnter={mouseEnter}
      >
        {family === 'parent' && (
          <Icon
            icon="parentS"
            size="48px"
            className={cn(classes.parent, classes.parent_s)}
          />
        )}
        {noFirst && (
          <Icon
            icon="parentL"
            size="72px"
            className={cn(classes.parent, classes.parent_l)}
          />
        )}
        <NavLink
          to={generateRegionalPath(`${newUrl}/${company.customerId}/general`)}
        >
          <Company
            nameCompany={
              company.companyName ? company.companyName : company.customerId
            }
            description={company.companySize}
            recordType={recordType(company)}
            country={company.country}
            domain={company.website}
            customerId={company.customerId}
          />
        </NavLink>
      </Table.Cell>
      <Table.Cell
        className={cn(classes.tableCell, row === 'r1' && classes.hov)}
        onMouseEnter={mouseEnter}
      >
        <CompanyStatus status={company.status} className={classes.status} />
      </Table.Cell>
      <Table.Cell
        className={cn(classes.tableCell, row === 'r2' && classes.hov)}
        onMouseEnter={mouseEnter}
      >
        <ProgressBar is={company.tmUtilized} of={company.tmLicenses} />
      </Table.Cell>
      <Table.Cell
        className={cn(classes.tableCell, row === 'r3' && classes.hov)}
        onMouseEnter={mouseEnter}
      >
        {`${company.psUtilized}/${company.psLicenses}`}
      </Table.Cell>
      <Table.Cell
        className={cn(classes.tableCell, row === 'r4' && classes.hov)}
        onMouseEnter={mouseEnter}
      >
        {company.plan ? (
          Array.isArray(company.plan) ? (
            <WithTooltip
              text={
                <TableParentTooltip
                  data={company.plan}
                  title={t('activity:customers:TOTAL_PLANS')}
                />
              }
              position={'top'}
            >
              <div>
                <Text size={4} className={classes.blue}>
                  {t('activity:customers:TOTAL_PLANS')}
                </Text>
              </div>
            </WithTooltip>
          ) : (
            company.plan
          )
        ) : (
          'NA'
        )}
      </Table.Cell>
      <Table.Cell
        className={cn(classes.tableCell, row === 'r5' && classes.hov)}
        onMouseEnter={mouseEnter}
      >
        {company.billingCycle ? (
          Array.isArray(company.billingCycle) ? (
            <WithTooltip
              text={
                <TableParentTooltip
                  data={company.billingCycle}
                  title={t('activity:customers:TOTAL_CYCLES')}
                />
              }
              position={'top'}
            >
              <div>
                <Text size={4} className={classes.blue}>
                  {t('activity:customers:TOTAL_CYCLES')}
                </Text>
              </div>
            </WithTooltip>
          ) : (
            company.billingCycle
          )
        ) : (
          'NA'
        )}
      </Table.Cell>
      <Table.Cell
        className={cn(
          classes.tableCell,
          row === 'r6' && classes.hov,
          family === 'parent' && classes.tableCell_bold
        )}
        onMouseEnter={mouseEnter}
      >
        {moneyFormater(company.arr)}
      </Table.Cell>
      <Table.Cell
        className={cn(
          classes.tableCell,
          row === 'r7' && classes.hov,
          family === 'parent' && classes.tableCell_bold
        )}
        onMouseEnter={mouseEnter}
      >
        <TableCoupon
          percent={company.discountPercentage}
          amount={company.discountAmount}
        />
      </Table.Cell>
      <Table.Cell
        className={cn(
          classes.tableCell,
          row === 'r8' && classes.hov,
          family === 'parent' && classes.tableCell_bold
        )}
        onMouseEnter={mouseEnter}
      >
        <DateTime date={company.firstPaymentDate} />
      </Table.Cell>
    </Table.Row>
  );
};

TableRow.propTypes = {
  company: PropTypes.object,
  family: PropTypes.string,
  noFirst: PropTypes.bool,
  row: PropTypes.string,
  mouseEnter: PropTypes.func
};

export default TableRow;
